import { Box, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { msg } from "@lingui/macro";
import OnStreamerFaq from "../views/Faq/OnStreamerFaq";
import OnTipperFaq from "../views/Faq/OnTipperFaq";

export const questions = {
  about: [
    {
      question: msg`Saweria itu apa sih?`,
      answer: msg`Saweria adalah layanan yang membantu kamu mendapatkan dukungan finansial dari penikmat karyamu, dengan dukungan sekali putus dan bukan langganan. Tidak untuk live streaming tapi bisa terintegrasi dengan platform seperti Youtube, Twitch, dll.`,
    },
    {
      question: msg`Apakah saya dapat menggunakan Saweria?`,
      answer: msg`Ya, Saweria terbuka untuk berbagai aktivitas seperti game streaming, tutorial, DJ show, talk show, dll, selama sesuai dengan hukum Indonesia. Lihat Syarat & Ketentuan di https://saweria.co/terms.`,
    },
    {
      question: msg`Saya bukan seorang streamer nih. Apakah masih bisa menggunakan Saweria?`,
      answer: msg`Tentu bisa! Dukungan masuk ke akun Saweria kamu meskipun tidak live. Kekurangan: tidak ada notifikasi real time saat donasi masuk, tapi bisa cek di menu 'Transaksi'.`,
    },
    {
      question: msg`Platform live streaming apa saja yang dapat terintegrasi dengan saweria?`,
      answer: msg`Saweria terintegrasi dengan software broadcasting yang mendukung 'Browser Source', seperti OBS atau SLOBS.`,
    },
    {
      question: msg`Bagaimana saya dapat menggunakan Saweria?`,
      answer: msg`Daftar di saweria.co/register, masukkan data diri, verifikasi akun, atur overlay untuk live streaming, pasang QR code dan link Saweria, terima dukungan. Verifikasi awal penting untuk pencairan dana.`,
    },
    {
      question: msg`Mengapa saya gagal mendaftar?`,
      answer: msg`Pastikan email pribadi dan username hanya berisi alfabet dan angka, tanpa simbol.`,
    },
    {
      question: msg`Bagaimana cara menggunakan overlay Saweria?`,
      answer: msg`Cek video tutorial untuk overlay Saweria pada OBS di saweria.co/tutorial.`,
    },
  ],
  tip: [
    {
      question: msg`Kok barcode Saweria tidak dapat di scan?`,
      answer: msg`Barcode Saweria bukan QRIS, scan dengan aplikasi kamera/barcode scanner. Akan diarahkan ke halaman donasi untuk memilih pembayaran.`,
    },
    {
      question: msg`Berapa dana minimal dukungan dan dana minimal yang dapat dicairkan?`,
      answer: msg`Dana minimal dukungan Rp 1.000, dana minimal yang dapat dicairkan Rp 50.000.`,
    },
    {
      question: msg`Apakah dana yang sudah dikirimkan bisa ditarik kembali?`,
      answer: msg`Tidak, dana dukungan yang dikirim tidak dapat ditarik kembali melalui Saweria.`,
    },
  ],
  cashout: [
    {
      question: msg`Berapa lama proses konfirmasi dukungan yang masuk sampai dapat dicairkan?`,
      answer: msg`Memakan waktu 3 hari kerja untuk konfirmasi oleh Payment Gateway. Setelah konfirmasi, saldo bertambah dan siap dicairkan. Contoh: dukungan 10 Januari 12.00 WIB, dana dapat dicairkan 13 Januari 12.00 WIB.`,
    },
    {
      question: msg`Berapa lama proses pencairan dana ke rekening saya?`,
      answer: msg`Dana dicairkan hari kerja langsung terkirim, di luar hari kerja/jam kerja dikirim jam kerja berikutnya. Contoh: request pencairan 12.00 malam, dana masuk jam kerja esok.`,
    },
    {
      question: msg`Kenapa saya gagal mencairkan dana?`,
      answer: msg`Cek rekening tujuan, koneksi internet, link konfirmasi email (berlaku 10 menit), gunakan browser berbeda. Jika masalah berlanjut, hubungi via email atau DM.`,
    },
  ],
  personalData: [
    {
      question: msg`Email yang saya daftarkan salah, apakah saya bisa menggantinya?`,
      answer: msg`Ya, kirim email ke help@saweria.co atau DM instagram/twitter untuk mengganti email terdaftar.`,
    },
    {
      question: msg`Saya lupa token 2FA saya, bagaimana untuk mendapatkan tokennya?`,
      answer: msg`Token 2FA dihasilkan otomatis oleh Google Authenticator/Authy dan berubah setiap saat. Jangan hapus aplikasi selama 2FA aktif di Saweria.`,
    },
    {
      question: msg`Apakah 2FA bisa dinonaktifkan?`,
      answer: msg`Bisa, kontak via email atau DM instagram/twitter untuk menonaktifkan 2FA.`,
    },
  ],
  etc: [
    {
      question: msg`Biaya apa saja yang harus saya atau donatur bayarkan?`,
      answer: msg`Transaksi terpotong 5% (6% untuk OVO), minimum 150 rupiah untuk biaya gateway dan operasional. Pencairan dana terpotong Rp 5.000.`,
    },
    {
      question: msg`Kemana saya bisa bertanya tentang hal lain yang belum tertera di FAQ?`,
      answer: msg`Hubungi via email help@saweria.co, DM twitter @saweriaco atau instagram @saweria_co. Layanan tidak 24 jam, untuk kerja sama email contact@saweria.co. Follow media sosial untuk info terbaru.`,
    },
    {
      question: msg`Apa yang dimaksud dengan biaya layanan?`,
      answer: msg`Biaya layanan adalah biaya tambahan yang dikenakan oleh penyedia layanan pembayaran (payment gateway) untuk setiap dukungan.`,
    },
    {
      question: msg`Apa yang dimaksud biaya layanan ditanggung streamer?`,
      answer: (<OnStreamerFaq/>)
    },
    {
      question: msg`Apa yang dimaksud biaya layanan ditanggung pendukung?`,
      answer: (<OnTipperFaq/>)
    },
  ],
};
